/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ApplicationsInputs */

const en_nav_applications = /** @type {(inputs: Nav_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applications`)
};

const de_nav_applications = /** @type {(inputs: Nav_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbungen`)
};

const fr_nav_applications = /** @type {(inputs: Nav_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Candidatures`)
};

const es_nav_applications = /** @type {(inputs: Nav_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitudes`)
};

const it_nav_applications = /** @type {(inputs: Nav_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Candidature`)
};

const nl_nav_applications = /** @type {(inputs: Nav_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sollicitaties`)
};

const pl_nav_applications = /** @type {(inputs: Nav_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplikacje`)
};

const fi_nav_applications = /** @type {(inputs: Nav_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakemukset`)
};

const da_nav_applications = /** @type {(inputs: Nav_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansøgninger`)
};

const sv_nav_applications = /** @type {(inputs: Nav_ApplicationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansökningar`)
};

/**
* | output |
* | --- |
* | "Applications" |
*
* @param {Nav_ApplicationsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const nav_applications = /** @type {((inputs?: Nav_ApplicationsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ApplicationsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nav_applications(inputs)
	if (locale === "fr") return fr_nav_applications(inputs)
	if (locale === "es") return es_nav_applications(inputs)
	if (locale === "it") return it_nav_applications(inputs)
	if (locale === "nl") return nl_nav_applications(inputs)
	if (locale === "pl") return pl_nav_applications(inputs)
	if (locale === "fi") return fi_nav_applications(inputs)
	if (locale === "da") return da_nav_applications(inputs)
	if (locale === "sv") return sv_nav_applications(inputs)
	return en_nav_applications(inputs)
});